import React, { useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { HomeIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import {
    HomeIcon as HomeIconSolid,
    UserCircleIcon as UserCircleIconSolid,
    CalendarDaysIcon,
    BoltIcon,
    SparklesIcon,
} from "@heroicons/react/24/solid";
import QurealSpotlight from "../creations/QurealSpotlight";
import styles from "./styles/NewMobileNavBar.module.css";
import cn from "classnames";

const NAV_ITEMS = [
    {
        key: "home",
        label: "Home",
        slug: "/home",
        Icon: HomeIconSolid,
        IconOutline: HomeIcon,
    },
    {
        key: "calendar",
        label: "Calendar",
        slug: "/creatives/content-calendar",
        Icon: CalendarDaysIcon,
        IconOutline: CalendarDaysIcon,
    },
    { key: "spotlight", center: true },
    {
        key: "sources",
        label: "Source",
        panel: "create",
        Icon: BoltIcon,
        IconOutline: BoltIcon,
    },
    {
        key: "settings",
        label: "You",
        slug: "/you",
        activeMatch: ["/you", "/settings"],
        Icon: UserCircleIconSolid,
        IconOutline: UserCircleIcon,
    },
];

function NewMobileNavBar({ me }) {
    const location = useLocation();
    const history = useHistory();
    const [openTrigger, setOpenTrigger] = useState(0);

    const isActive = (item) => {
        if (item.panel) {
            return (
                new URLSearchParams(location.search).get("panel") === item.panel
            );
        }
        const matches = item.activeMatch || [item.slug];
        return matches.some((p) => p && location.pathname.startsWith(p));
    };

    return (
        <div className={styles.nav_container}>
            <QurealSpotlight me={me} externalOpen={openTrigger} noIcon={true} />
            <div className={styles.nav_bar}>
                {NAV_ITEMS.map((item) => {
                    if (item.center) {
                        return (
                            <div key="spotlight" className={styles.center_slot}>
                                <button
                                    className={styles.spotlight_btn}
                                    onClick={() => setOpenTrigger((t) => t + 1)}
                                    aria-label="Open Spotlight"
                                >
                                    <SparklesIcon
                                        style={{
                                            width: "24px",
                                            color: "#FFFFFF",
                                        }}
                                    />
                                </button>
                            </div>
                        );
                    }

                    const active = isActive(item);
                    const IconComponent = active ? item.Icon : item.IconOutline;

                    if (item.panel) {
                        return (
                            <div
                                key={item.key}
                                className={styles.nav_item}
                                onClick={() =>
                                    history.push(
                                        `${location.pathname}?panel=${item.panel}`
                                    )
                                }
                            >
                                <span
                                    className={
                                        active
                                            ? styles.icon_active
                                            : styles.icon_inactive
                                    }
                                >
                                    <IconComponent style={{ width: "24px" }} />
                                </span>
                                <span
                                    className={cn(styles.label, {
                                        [styles.label_active]: active,
                                    })}
                                >
                                    {item.label}
                                </span>
                            </div>
                        );
                    }

                    return (
                        <Link
                            to={item.slug}
                            key={item.key}
                            className={styles.nav_item}
                        >
                            <span
                                className={
                                    active
                                        ? styles.icon_active
                                        : styles.icon_inactive
                                }
                            >
                                <IconComponent style={{ width: "24px" }} />
                            </span>
                            <span
                                className={cn(styles.label, {
                                    [styles.label_active]: active,
                                })}
                            >
                                {item.label}
                            </span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}

export default NewMobileNavBar;
